import React, { useContext, useEffect, useState } from "react";
import { TranslatorContext } from "../../context/Translator";
import { Row, Col, Tab, Tabs } from "react-bootstrap";
import { LabelFieldComponent, LabelTextareaComponent } from "../../components/fields";
import { ButtonComponent } from "../../components/elements";
import { FileUploadComponent } from "../../components"; 
import PageLayout from "../../layouts/PageLayout";
import { toast } from 'react-toastify';
import { useParams } from "react-router-dom";
import { showCustomer, updateCustomerData } from "../../APIs/CustomersRequests";


import { pdfjs } from 'react-pdf';
import 'react-pdf/dist/esm/Page/AnnotationLayer.css';
import 'react-pdf/dist/esm/Page/TextLayer.css';

export default function CustomerAccountPage() {

    pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.min.js`;
    const {id} = useParams();

    const { t } = useContext(TranslatorContext);
    const [name, setName] = useState('');
    const [email, setEmail] = useState('');
    const [phoneNumber, setPhoneNumber] = useState('');
    const [nationality, setNationality] = useState('');
    const [birthDate, setBirthDate] = useState('');
    const [documentNumber, setDocumentNumber] = useState('');
    const [documentExpiryDate, setDocumentExpiryDate] = useState('');
    const [submissionStatus, setSubmissionStatus] = useState('');
    const [address, setAddress] = useState('');
    const [occupation, setOccupation] = useState('');
    const [documentType, setDocumentType] = useState('');
    const [isBlocked, setIsBlocked] = useState('0');
    const [blockReason, setBlockReason] = useState('');
    const [type, setType] = useState('');
    const [image, setImage] = useState('');
    const [signatureImage, setSignatureImage] = useState('');
    const [documentImageFront, setDocumentImageFront] = useState('');
    const [documentImageBack, setDocumentImageBack] = useState('');
    const [supportDocument, setSupportDocument] = useState('');
    const [allowedSimsNumber, setAllowedSimsNumber] = useState(0);
    const [approvedSimsNumber, setApprovedSimsNumber] = useState(0);
    const [permissionLitterImage, setPermissionLitterImage] = useState('');
    const [created_at, setCreatedAt] = useState('');
    const [kycFile, setKycFile] = useState('');
    const [kycFileLink, setKycFileLink] = useState('');


    useEffect(()=> {
        if(id){
            showCustomerFunction();
        }
    },[]);
    const showCustomerFunction = async () => {
        showCustomer(id).then(async(res)=> {
            setName(res.data.data.name);
            setEmail(res.data.data.email);
            setPhoneNumber(res.data.data.phone_number);
            setNationality(res.data.data.nationality);
            setBirthDate(res.data.data.birth_date);
            setDocumentExpiryDate(res.data.data.document_expiry_date);
            setSubmissionStatus(res.data.data.submission_status);
            setAddress(res.data.data.address);
            setOccupation(res.data.data.occupation);
            setDocumentType(res.data.data.document_type);
            setImage(res.data.data.image ==''?'/images/avatar/profile.jpg': res.data.data.image);
            setSignatureImage(res.data.data.signature_image ==''? '/images/default.png': res.data.data.signature_image);
            setDocumentImageFront(res.data.data.document_image_front ==''? '/images/default.png': res.data.data.document_image_front);
            setDocumentImageBack(res.data.data.document_image_back ==''? '/images/default.png': res.data.data.document_image_back);
            setPermissionLitterImage(res.data.data.permission_litter_image ==''? '/images/default.png': res.data.data.permission_litter_image);
            setCreatedAt(res.data.data.created_at);
            setAllowedSimsNumber(res.data.data.allowed_sims_number);
            setApprovedSimsNumber(res.data.data.approved_sims_number);
            setIsBlocked(res.data.data.is_blocked?'1':'0');
            setType(res.data.data.type);
            setBlockReason(res.data.data.block_reason);
            setDocumentNumber(res.data.data.document_number);
            setKycFile(res.data.data.kyc_file_encoded);
            setKycFileLink(res.data.data.kyc_file);
            setSupportDocument(res.data.data.support_document_image);
        });
    }

    const updateCustomerAction = () => {
        let isBlockedItem = isBlocked == '1'?true:false;
        updateCustomerData(id,allowedSimsNumber,isBlockedItem,blockReason).then((res)=> {
            const notify = () => toast.success(res.data.message);
            notify();
        });
    }

    const handleUpdateCustomer = () => {
        updateCustomerAction();
    }
    
    return (
        <PageLayout>
            <Row>
                <Col xl={12}>
                    <div className="mc-card">
                        <div className='mc-breadcrumb'>
                            <h3 className="mc-breadcrumb-title">{t('customer_account')}</h3>
                        </div>
                    </div>
                </Col>
                <Col xl={12}>
                    <div className="mc-card">
                        <Tabs defaultActiveKey="profile" id="mc" className="mc-tabs">
                            <Tab eventKey="profile" className="mc-tabpane profile">
                                <div className="mc-tab-card">
                                    <h6 className="mc-tab-card-title">{t('public_information')}</h6>
                                    {
                                        type == 'individual' ?
                                        <Row>
                                        <Col xl={4}>
                                            <div className="mc-user-avatar-upload">
                                                <div className="mc-user-avatar">
                                                    <img src={image} alt="avatar" />
                                                </div>
                                                {/* <FileUploadComponent icon="cloud_upload" text={t('upload')} /> */}
                                            </div>
                                        </Col>
                                        <Col xl={8}>
                                            <Row>
                                                <Col xl={12}><LabelFieldComponent disabled type="text" label={t('fullname')} fieldSize="w-100 h-md" onChange={(e)=>setName(e.target.value)} value={name}/></Col>
                                                <Col xl={12}><LabelFieldComponent disabled type="text" label={t('email')} fieldSize="w-100 h-md" onChange={(e)=>setName(e.target.value)} value={email}/></Col>

                                            </Row>
                                        </Col>
                                    </Row>
                                    :
                                    <Row>
                                        
                                        <Col xl={12}>
                                            <Row>
                                                <Col xl={12}><LabelFieldComponent disabled type="text" label={t('fullname')} fieldSize="w-100 h-md" onChange={(e)=>setName(e.target.value)} value={name}/></Col>
                                                <Col xl={12}><LabelFieldComponent disabled type="text" label={t('email')} fieldSize="w-100 h-md" onChange={(e)=>setName(e.target.value)} value={email}/></Col>

                                            </Row>
                                        </Col>
                                    </Row>
                                    }
                                    
                                </div>
                                <div className="mc-tab-card">
                                    <h6 className="mc-tab-card-title">{t('private_information')}</h6>
                                    <Row>
                                        
                                        <Col xl={6}><LabelFieldComponent disabled type="text" label={t('phone_number')}  fieldSize="w-100 h-md" value={phoneNumber} onChange={(e)=> setEmail(e.target.value)}/></Col>
                                        <Col xl={6}><LabelFieldComponent disabled type="text" label={t('nationality')}  fieldSize="w-100 h-md" value={nationality} onChange={(e)=> setEmail(e.target.value)}/></Col>
                                        <Col xl={6}><LabelFieldComponent disabled type="text" label={t('birth_date')}  fieldSize="w-100 h-md" value={birthDate} onChange={(e)=> setEmail(e.target.value)}/></Col>
                                        <Col xl={6}><LabelFieldComponent disabled type="text" label={t('document_number')}  fieldSize="w-100 h-md" value={documentNumber} onChange={(e)=> setDocumentNumber(e.target.value)}/></Col>

                                        <Col xl={6}><LabelFieldComponent disabled type="text" label={t('document_expiry_date')}  fieldSize="w-100 h-md" value={documentExpiryDate} onChange={(e)=> setEmail(e.target.value)}/></Col>
                                        <Col xl={6}><LabelFieldComponent disabled type="text" label={t('submission_status')}  fieldSize="w-100 h-md" value={submissionStatus} onChange={(e)=> setEmail(e.target.value)}/></Col>
                                        <Col xl={6}><LabelFieldComponent disabled type="text" label={t('address')}  fieldSize="w-100 h-md" value={address} onChange={(e)=> setEmail(e.target.value)}/></Col>
                                        <Col xl={6}><LabelFieldComponent disabled type="text" label={t('occupation')}  fieldSize="w-100 h-md" value={occupation} onChange={(e)=> setEmail(e.target.value)}/></Col>
                                        <Col xl={6}><LabelFieldComponent disabled type="text" label={t('document_type')}  fieldSize="w-100 h-md" value={documentType} onChange={(e)=> setEmail(e.target.value)}/></Col>
                                        <Col xl={6}><LabelFieldComponent disabled type="text" label={t('type')}  fieldSize="w-100 h-md" value={type} onChange={(e)=> setType(e.target.value)}/></Col>

                                        <Col xl={6}><LabelFieldComponent type="text" label={t('allowed_sims_number')}  fieldSize="w-100 h-md" value={allowedSimsNumber} onChange={(e)=> setAllowedSimsNumber(e.target.value)}/></Col>
                                        <Col xl={6}><LabelFieldComponent type="text" label={t('approved_sims_number')}  fieldSize="w-100 h-md" value={approvedSimsNumber} onChange={(e)=> setApprovedSimsNumber(e.target.value)}/></Col>

                                        <Col xl={6}><LabelFieldComponent label={t('status')}  fieldSize="w-100 h-md" option={[{id:'1',name:t("blocked")},{id:'0',name:t("clear")}]} value={isBlocked} onChange={(e)=> {console.log(e.target.value);setIsBlocked(e.target.value)}}/></Col>
                                        {
                                            isBlocked == '1' &&
                                            <Col xl={12}><LabelTextareaComponent label={t('block_reason')} fieldSize="w-100 h-5xl" value={blockReason} onChange={(e)=> setBlockReason(e.target.value)}/></Col>
                                        }

                                        
                                        <Col xl={6}><LabelFieldComponent disabled type="disabled" label={t('creation date')}  fieldSize="w-100 h-md" value={created_at}/></Col>


                                        <Col xl={6}>
                                            <h6 className="mc-divide-title mb-4">{t('signature_image')}</h6>
                                            <div className="mc-product-view-gallery">
                                                <img src={signatureImage} alt="product"/>
                                                
                                            </div>
                                        </Col>

                                        <Col xl={6}>
                                            <h6 className="mc-divide-title mb-4">{t('document_image_front')}</h6>
                                            <div className="mc-product-view-gallery">
                                                <img src={documentImageFront} alt="product"/>
                                                
                                            </div>
                                        </Col>

                                        <Col xl={6}>
                                            <h6 className="mc-divide-title mb-4">{t('document_image_back')}</h6>
                                            <div className="mc-product-view-gallery">
                                                <img src={documentImageBack} alt="product"/>
                                                
                                            </div>
                                        </Col>

                                        {
                                            permissionLitterImage &&
                                            <Col xl={6}>
                                            <h6 className="mc-divide-title mb-4">{t('permission_litter_image')}</h6>
                                            <div className="mc-product-view-gallery">
                                                <img src={permissionLitterImage} alt="product"/>
                                            </div>
                                        </Col>
                                        }

                                        {
                                            supportDocument &&
                                            <Col xl={6}>
                                            <h6 className="mc-divide-title mb-4">{t('support_document')}</h6>
                                            <div className="mc-product-view-gallery">
                                                <img src={supportDocument} alt="product"/>
                                            </div>
                                        </Col>
                                        }
                                        
                                        {
                                            kycFile!=='' && kycFile == null &&
                                            <Col xl={6}>
                                                <h6 className="mc-divide-title mb-4">{t('customer_kyc')}</h6>
                                                <div className="mc-product-view-gallery">
                                                    <iframe 
                                                        src={`data:application/pdf;base64,${kycFile}`}
                                                        width="100%" 
                                                        height="650px"
                                                        title="PDF Viewer"
                                                        >
                                                        <p>Your browser does not support PDFs. 
                                                            <a href={kycFileLink}>Download the PDF</a>.
                                                        </p>
                                                    </iframe>
                                                </div>
                                            </Col>
                                        }
                                        {
                                            type === 'company' &&
                                            <Col xl={6}>
                                            <h6 className="mc-divide-title mb-4">{t('employee_id')}</h6>
                                            <div className="mc-product-view-gallery">
                                                <img src={image} alt="product"/>
                                                
                                            </div>
                                        </Col>
                                        }

                                    </Row>
                                </div>
                                
                                <ButtonComponent className="mc-btn primary" icon="verified" text={t('update')} onClick={()=>handleUpdateCustomer()}/>
                            </Tab>
                           
                            
                        </Tabs>
                    </div>
                </Col>
            </Row>
        </PageLayout>
    )
}